// extracted by mini-css-extract-plugin
module.exports = {"table_head":"styles_table_head__1S2RJ","table":"styles_table__Lmoio"};